import { parseAdditionalData } from './findingTarget';

function text(value) {
  return String(value ?? '').trim();
}

function keyOf(value) {
  return text(value).replace(/[_\s]+/g, '-').toLowerCase();
}

function firstPresent(...values) {
  return values.find(value => text(value) !== '');
}

export function passiveEvidenceConfidenceOf(finding) {
  const ad = parseAdditionalData(finding) ?? {};
  return firstPresent(
    finding?.evidenceConfidence,
    finding?.evidence_confidence,
    finding?.detail?.evidenceConfidence,
    finding?.detail?.evidence_confidence,
    ad.evidenceConfidence,
    ad.evidence_confidence,
  ) ?? '';
}

export function passiveEvidenceSourceOf(finding) {
  const ad = parseAdditionalData(finding) ?? {};
  return firstPresent(
    finding?.passiveVulnerabilitySource,
    finding?.passive_vulnerability_source,
    finding?.vulnerabilitySource,
    finding?.vulnerability_source,
    finding?.evidenceSource,
    finding?.evidence_source,
    finding?.sourceType,
    finding?.source_type,
    finding?.detail?.passiveVulnerabilitySource,
    finding?.detail?.passive_vulnerability_source,
    finding?.detail?.vulnerabilitySource,
    finding?.detail?.vulnerability_source,
    finding?.detail?.evidenceSource,
    finding?.detail?.evidence_source,
    finding?.detail?.sourceType,
    finding?.detail?.source_type,
    ad.passiveVulnerabilitySource,
    ad.passive_vulnerability_source,
    ad.vulnerabilitySource,
    ad.vulnerability_source,
    ad.evidenceSource,
    ad.evidence_source,
    ad.sourceType,
    ad.source_type,
    finding?.source,
    finding?.sourceModule,
    finding?.module,
    finding?.detail?.source,
    finding?.detail?.sourceModule,
    ad.source,
    ad.sourceModule,
  ) ?? '';
}

export function passiveEvidenceLabelForConfidence(value) {
  const key = keyOf(value);
  if (key === 'confirmed') return 'Confirmed evidence';
  if (key === 'version-banner' || key === 'banner' || key === 'service-banner') return 'Version/banner based';
  if (key === 'os-version-match') return 'OS version based';
  if (key === 'installed-patch') return 'Installed patch evidence';
  if (key === 'software-inventory' || key === 'installed-software-match' || key === 'inventory' || key === 'endpoint-inventory') return 'Software inventory based';
  if (key === 'inferred') return 'Inferred evidence';
  return '';
}

export function passiveEvidenceLabelForSource(value) {
  const key = keyOf(value);
  if (!key) return '';
  if (key.includes('software-inventory') || key.includes('endpoint-inventory')) return 'Software inventory source';
  if (key.includes('operating-system') || key.includes('os-hotfix')) return 'OS patch source';
  if (key.includes('version-banner') || key.includes('service-banner') || key === 'banner') return 'Banner source';
  if (key.includes('passive-vulnerability') || key.includes('passivefindings')) return 'Passive source';
  return '';
}

export function passiveEvidenceBadges(finding) {
  const confidence = passiveEvidenceConfidenceOf(finding);
  const source = passiveEvidenceSourceOf(finding);
  const confidenceLabel = passiveEvidenceLabelForConfidence(confidence);
  const sourceLabel = passiveEvidenceLabelForSource(source);
  const badges = [];

  if (confidenceLabel) {
    badges.push({
      key: `confidence:${keyOf(confidence)}`,
      label: confidenceLabel,
      tone: keyOf(confidence) === 'confirmed' ? 'confirmed' : 'passive',
    });
  }

  if (sourceLabel && sourceLabel !== confidenceLabel.replace(' based', ' source')) {
    badges.push({
      key: `source:${keyOf(source)}`,
      label: sourceLabel,
      tone: 'source',
    });
  }

  const passiveKeys = `${keyOf(confidence)} ${keyOf(source)}`;
  if (passiveKeys.includes('version-banner') || passiveKeys.includes('banner') || passiveKeys.includes('software-inventory') || passiveKeys.includes('installed-software-match') || passiveKeys.includes('os-version-match') || passiveKeys.includes('operating-system') || passiveKeys.includes('os-hotfix') || passiveKeys.includes('passive-vulnerability') || passiveKeys.includes('passivefindings') || passiveKeys.includes('inferred')) {
    badges.push({
      key: 'validation:not-exploit-validated',
      label: 'Not exploit-validated',
      tone: 'caution',
    });
  }

  return badges;
}
